import * as React from "react";
import { Button, Margin, P, ErrorNotification } from "@ovotech/element";
import { useNavigate } from "react-router";

export const SorryThereWasProblem = () => {
  const navigate = useNavigate();

  return (
    <>
      <ErrorNotification
        id="sorry"
        title="Sorry, there was a problem"
        style={{ marginBottom: "4rem" }}
      >
        <P>
          Please try again. If this doesn&apos;t work, get in touch with us at
          electricvehicles@ovoenergy.com
        </P>
      </ErrorNotification>

      <Margin top={8} />
      <Button onClick={() => navigate(-1)} data-testid="try-again-button">
        Try again
      </Button>
    </>
  );
};
